import axios from "axios";
import { notifyError } from "../../../utils/toasts";

export const fetchMoveAllowedZones = ({ segment_id, time_now }) =>
  axios
    .get(
      `http://qcan-dev.smart-era.com:8001/cl/v1/production-plan/move-allowed-zones`,
      {
        params: { segment_id, time_now },
      }
    )
    .catch((error) => {
      notifyError(error?.response?.data?.message || error.message);
    });

export const fetchCreateAllowedZones = ({
  order_item_id,
  group_id,
  operation_id,
  operation_quantity,
  duration,
  time_now,
}) =>
  axios
    .get(
      `http://qcan-dev.smart-era.com:8001/cl/v1/production-plan/create-allowed-zones`,
      {
        params: {
          order_item_id,
          group_id,
          operation_id,
          operation_quantity,
          duration,
          time_now,
        },
      }
    )
    .catch((error) => {
      notifyError(error?.response?.data?.message || error.message);
    });

export const fetchDeleteSegment = ({ id }) =>
  axios
    .delete(
      `http://qcan-dev.smart-era.com:8001/cl/v1/production-plan/segment/${id}`
    )
    .catch((error) => {
      notifyError(error?.response?.data?.message || error.message);
    });

// eslint-disable-next-line no-undef
export const fetchEquipment = ({ divisionId: division_id }) =>
  axios
    .get(`http://qcan-dev.smart-era.com:8001/cl/v1/equipment`, {
      params: { division_id },
    })
    .catch((error) => {
      notifyError(error?.response?.data?.message || error.message);
    });

export const fetchProductPlan = ({ divisionId: division_id, hash }) =>
  axios
    .get(
      `http://qcan-dev.smart-era.com:8001/cl/v1/production-plan/${division_id}/check-updates`,
      hash
        ? {
            params: {
              hash,
            },
          }
        : {}
    )
    .catch((error) => {
      notifyError(error?.response?.data?.message || error.message);
    });

export const fetchCreateNewSegment = ({
  divisionId: division_id,
  operation_quantity,
  parallel_quantity,
  start_time,
  duration,
  order_item_id,
  operation_id,
  group_id,
  equipment_id,
}) =>
  axios
    .post(`http://qcan-dev.smart-era.com:8001/cl/v1/production-plan/segment`, {
      division_id,
      operation_quantity,
      parallel_quantity,
      start_time,
      duration,
      order_item_id,
      operation_id,
      group_id,
      equipment_id,
    })
    .catch((error) => {
      notifyError(error?.response?.data?.message || error.message);
    });

export const fetchMoveExistSegment = ({ id, new_start_time, equipment_id }) =>
  axios
    .patch(
      `http://qcan-dev.smart-era.com:8001/cl/v1/production-plan/segment/${id}/move`,
      {
        new_start_time,
        equipment_id,
      }
    )
    .catch((error) => {
      notifyError(error?.response?.data?.message || error.message);
    });

export const fetchGetOrderItem = (orderItemId) =>
  axios
    .get(
      `http://qcan-dev.smart-era.com:8001/cl/v1/production-plan/order-item/${orderItemId}`
    )
    .catch((error) => {
      notifyError(error?.response?.data?.message || error.message);
    });

export const fetchOrders = async (divisionId) => {
  try {
    const response = await axios.get(
      `http://qcan-dev.smart-era.com:8001/cl/v1/production-plan/${divisionId}/order`
    );
    const data = await response.data;

    return data;
  } catch (error) {
    notifyError(error?.response?.data?.message || error.message);
  }
};
